export default __webpack_public_path__ + "static/media/teacher_trsp.20519d63.gif";